//Generated File 
export default class EditScreenFieldLayout{
	static readonly alone = `alone`;
	static readonly normal = `normal`;
	static readonly spanned = `spanned`;
	static readonly spanned2 = `spanned2`;
	static readonly startnewline = `startnewline`;
}
